import { TRACK_TYPE, REVIEW_PAGE_VIEW } from 'shared/helpers/analytics/constants';
import { PDP_EVENTS } from 'shared/helpers/analytics/constants/pdpEvents';

import NFA from 'shared/helpers/analytics/NFAnalytics';

interface IReviewPageLoadProps {
  productId: string;
  reviewRatingData: any;
  reviewData: any;
}

export const onReviewPageLoad = ({
  productId,
  reviewRatingData,
  reviewData,
}: IReviewPageLoadProps) => {
  if (!reviewData.length) return;
  const { star_rating = 0, review_count = 0, star_rating_count = 0 } = reviewRatingData;
  const reviewImagesCount =
    reviewData.filter((review: any) => review?.images.length > 0).length || 0;

  NFA.track({
    type: TRACK_TYPE.PAGELOAD,
    event: PDP_EVENTS.ON_REVIEW_PAGELOAD,
    data: {
      productID: productId,
      pagetype: REVIEW_PAGE_VIEW,
      pdpReviewCount: review_count,
      pdpReviewCountWithImages: reviewImagesCount,
      pdpOverallRating: star_rating,
      verifiedRatingsCount: star_rating_count,
    },
  });
};
